import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/footer.css";

import startupChattisgarh from "../assests/images/chattisgarh_startup.png";
import startupIndia from "../assests/logo/startup_india.png";
import msme from "../assests/images/msme.png";
import startupOdisha from "../assests/logo/startup-odisha.png";
import oraclePartner from "../assests/images/oracle-partner-logo.png";
import zohoPartner from "../assests/images/zoho-partner-logo-2.png";
import oddoPartner from "../assests/images/oddo Partner.png";

import linkedin from "../assests/svg/linkedin.svg";
import twitter from "../assests/svg/twitter.svg";
import instagram from "../assests/svg/instagram.svg";
import facebook from "../assests/svg/facebook.svg";

import { SITE, CONTACT, SOCIAL, OFFICES } from "../config/site";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="premium-footer">
      <div className="footer-gradient-border"></div>

      <div className="footer-main-container">
        {/* Logos / recognition */}
        <div className="footer-logos-container">
          <div className="logos-section recognized-section">
            <div className="section-header">
              <span className="header-icon">🏆</span>
              <h4 className="logos-heading">Recognized By</h4>
              <span className="header-line"></span>
            </div>
            <div className="logos-grid">
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={startupOdisha} alt="Startup Odisha" className="partner-logo" />
                </div>
                <span className="logo-label">Startup Odisha</span>
              </div>
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={startupChattisgarh} alt="Startup Chhattisgarh" className="partner-logo" />
                </div>
                <span className="logo-label">Startup Chhattisgarh</span>
              </div>
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={startupIndia} alt="Startup India" className="partner-logo" />
                </div>
                <span className="logo-label">Startup India</span>
              </div>
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={msme} alt="MSME" className="partner-logo" />
                </div>
                <span className="logo-label">MSME Registered</span>
              </div>
            </div>
          </div>

          <div className="section-divider"></div>

          <div className="footer-ratings-section">
            <div className="section-header">
              <span className="header-icon">⭐</span>
              <h3 className="section-title">Our Ratings & Reviews</h3>
              <span className="header-line"></span>
            </div>
            <div className="ratings-wrapper">
              <a
                href="https://www.ambitionbox.com/overview/cloudare-technologies-overview"
                className="rating-card ambitionbox-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="rating-card-inner">
                  <img
                    src="https://employer.ambitionbox.com/api/badge/917985?badge-type=ratings-detailed"
                    alt="AmbitionBox rating for Cloudare Technologies"
                    className="ambitionbox-badge"
                  />
                </div>
              </a>
              <a
                href="https://www.glassdoor.co.in/Reviews/Cloudare-Technologies-Reviews-E6198003.htm"
                className="rating-card glassdoor-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="glassdoor-badge">
                  <div className="glassdoor-content">
                    <div className="glassdoor-rating">
                      <span className="rating-number">4.2</span>
                      <div className="rating-stars" aria-hidden="true">
                        <span className="star filled">★</span>
                        <span className="star filled">★</span>
                        <span className="star filled">★</span>
                        <span className="star filled">★</span>
                        <span className="star half">★</span>
                      </div>
                    </div>
                    <span className="glassdoor-text">Rating on Glassdoor</span>
                    <span className="glassdoor-reviews">Based on 25+ reviews</span>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className="section-divider"></div>

          <div className="logos-section partners-section">
            <div className="section-header">
              <span className="header-icon">🤝</span>
              <h4 className="logos-heading">Trusted & Official Partners</h4>
              <span className="header-line"></span>
            </div>
            <div className="logos-grid partners-grid">
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={oraclePartner} alt="Oracle Partner" className="partner-logo" />
                </div>
                <span className="logo-label">Oracle Partner</span>
              </div>
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={zohoPartner} alt="Zoho Partner" className="partner-logo" />
                </div>
                <span className="logo-label">Zoho Partner</span>
              </div>
              <div className="logo-item">
                <div className="logo-image-wrapper">
                  <img src={oddoPartner} alt="Odoo Partner" className="partner-logo" />
                </div>
                <span className="logo-label">Odoo Partner</span>
              </div>
            </div>
          </div>
        </div>

        {/* Nav / contact / global presence */}
        <div className="footer-info-grid">
          {/* Services / Quick links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Solutions</h4>
            <ul className="footer-links">
              <li><NavLink to="/services/oracle">Oracle Fusion / EBS</NavLink></li>
              <li><NavLink to="/services/netsuite">NetSuite</NavLink></li>
              <li><NavLink to="/services/zoho">Zoho</NavLink></li>
              <li><NavLink to="/services/odoo">Odoo</NavLink></li>
              <li><NavLink to="/tax/ksa">ZATCA E-Invoicing</NavLink></li>
              <li><NavLink to="/tax/malaysia">LHDN E-Invoicing</NavLink></li>
              <li><NavLink to="/tax/uae">FTA UAE</NavLink></li>
              <li><NavLink to="/tax/india">GST E-Invoicing</NavLink></li>
              <li><NavLink to="/tax/france">France (Factur-X)</NavLink></li>
              <li><NavLink to="/tax/eu">EU PEPPOL</NavLink></li>
              <li><NavLink to="/einvoicing-erp-integration">E-Invoicing + ERP</NavLink></li>
              <li><NavLink to="/gsp-asp-pdp">GSP / ASP / PDP guide</NavLink></li>
              <li><NavLink to="/partners">Partners</NavLink></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <ul className="footer-links">
              <li><NavLink to="/about">About Us</NavLink></li>
              <li><NavLink to="/locations">Locations</NavLink></li>
              <li><NavLink to="/success-stories">Success Stories</NavLink></li>
              <li><NavLink to="/faq">FAQ</NavLink></li>
              <li><NavLink to="/awards-and-achievements">Awards & Achievements</NavLink></li>
              <li><NavLink to="/events-and-webinars">Webinars</NavLink></li>
              <li>
                <a href={SOCIAL.blog} target="_blank" rel="noopener noreferrer">
                  Blogs
                </a>
              </li>
              <li>
                <a href={SOCIAL.careers} target="_blank" rel="noopener noreferrer">
                  Careers
                </a>
              </li>
              <li><NavLink to="/raipur">Raipur Office</NavLink></li>
              <li>
                <a href={SOCIAL.einvoiceGlobal} target="_blank" rel="noopener noreferrer">
                  eInvoice.Global ↗
                </a>
              </li>
              <li>
                <a href={SOCIAL.edynoor} target="_blank" rel="noopener noreferrer">
                  Edynoor ↗
                </a>
              </li>
              <li><NavLink to="/contact-us">Contact Us</NavLink></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Get in Touch</h4>
            <ul className="footer-contact">
              <li>
                📧 <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </li>
              <li>
                📞 <a
                  href={CONTACT.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                📅{" "}
                <a
                  href={CONTACT.calendly}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book a Slot
                </a>
              </li>
            </ul>

            <div className="footer-social">
              <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <img src={linkedin} alt="LinkedIn" />
              </a>
              <a href={SOCIAL.twitter} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                <img src={twitter} alt="X (Twitter)" />
              </a>
              <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <img src={instagram} alt="Instagram" />
              </a>
              <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <img src={facebook} alt="Facebook" />
              </a>
            </div>
          </div>

          <div className="footer-col footer-col--single">
            <h4 className="footer-col-title">Legal</h4>
            <ul className="footer-links">
              <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
              <li><NavLink to="/terms">Terms of Service</NavLink></li>
              <li><NavLink to="/refund-policy">Refund Policy</NavLink></li>
            </ul>
          </div>
        </div>

        {/* Global presence */}
        <div className="global-presence-section">
          <div className="section-header">
            <span className="header-icon">🌍</span>
            <h4 className="section-title">Global Presence</h4>
            <span className="header-line"></span>
          </div>
          <div className="address-cards-container">
            {OFFICES.map((office) => (
              <div className="address-card" key={office.title}>
                <div className="address-card-header">
                  <span className="location-dot"></span>
                  <span className="address-title">{office.title}</span>
                </div>
                <p className="address-text">
                  {office.lines.map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < office.lines.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom-bar">
        <div className="bottom-bar-content">
          <p className="copyright-text">
            © {currentYear} {SITE.legalName}. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
